import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';
import i18n from '../../translations/i18n';

const YesNoFilterField = props => (
  <SelectField
    fullWidth
    value={props.filter ? props.filter.value : ''}
    onChange={(event, index, value) => props.onFilterChange(value)}
  >
    <MenuItem value="" primaryText={props.t('all')} />
    <MenuItem value primaryText={props.t('yes')} />
    <MenuItem value={false} primaryText={props.t('no')} />
  </SelectField>
);

const extended = translate(['translations'], { i18n })(YesNoFilterField);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/filters/YesNoFilterField.js